import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { getFeedThunk } from '../../../actions/feeds';
import { useAppDispatch } from '../../../store';
import { Nullable } from '../../../types/common';
import { Feeds } from '../../../types/Endpoints/feeds';
import { Feed } from '../components/Feed';

export const EditFeed: FC = () => {
    const { feedId } = useParams<{feedId: string}>();
    const dispatch = useAppDispatch();
    const [data, setData] = useState<Nullable<Feeds[number]>>(null);

    useEffect(() => {
        (async () => {
            const response = await dispatch(getFeedThunk(+feedId));
            setData(response.payload);
        })();
    }, []);

    return (
        <Feed type="edit" data={data} />
    );
};
